import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from "@material-ui/core";
import { ColorBox } from "material-ui-color";


const useStyles = makeStyles((theme) => ({
    btnWrapper: {
        position: "relative",
    },
}));

const ColorBoxModal = ({ onChange, currentColor, handleClose, open }) => {

    const classes = useStyles();
    const [selectedColor, setSelectedColor] = useState(currentColor);

    useEffect(() => {
        if (open) {
            setSelectedColor(currentColor);
        }
    }, [currentColor, open]);

    const handleOk = () => {
        let colorObj = selectedColor;
        if (typeof selectedColor === "string") {
            const hex = selectedColor.replace("#", "");
            colorObj = { hex, raw: selectedColor.startsWith("#") ? selectedColor : `#${selectedColor}` };
        } else if (selectedColor && typeof selectedColor === "object") {
            const hex = selectedColor.hex ? selectedColor.hex.replace("#", "") : (selectedColor.raw ? selectedColor.raw.replace("#", "") : "");
            colorObj = { ...selectedColor, hex };
        } else {
            colorObj = { hex: "000000", raw: "#000000" };
        }
        onChange(colorObj);
        handleClose();
    };

    return (

        <Dialog open={open} onClose={handleClose}>

            <DialogTitle>Escolha uma cor</DialogTitle>
            <DialogContent>
                <ColorBox
                    disableAlpha={true}
                    hslGradient={false}
                    style={{ margin: '20px auto 0' }}
                    value={selectedColor}
                    onChange={setSelectedColor} />
            </DialogContent>

            <DialogActions>

                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    className={classes.btnWrapper}
                    onClick={handleOk} >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default ColorBoxModal;